ACDiscountApp.PDPage.DisplayTiers = function () {
   // var perfEntries = performance.getEntriesByType("navigation");
   //  if (perfEntries[0].type === "back_forward") {location.reload(); }
  let intervalId; // Variable to store the interval ID
      var storeTime = globalFields.Storetime();
    // Parse the date string into individual components
    let [currentYear, currentMonth, currentDay, currentHours, currentMinutes, currentSeconds] = storeTime.split(/[\sT:-]/);
    currentYear = parseInt(currentYear);
    currentMonth = parseInt(currentMonth); // Months are zero-based in JavaScript
    currentDay = parseInt(currentDay);
    currentHours = parseInt(currentHours);
    currentMinutes = parseInt(currentMinutes);
    currentSeconds = parseInt(currentSeconds);
  
  function makeTimer(end_date) {
    if (globalFields.isProduct_Page) {
        if (end_date != null) {
          jQuery("#ac_countDown").css("display", "inline-block");
          jQuery("#ac_countDown").css("margin-bottom", "25px");
          jQuery("#ac_countDown").css("margin-top", "6px");
          jQuery("#ac_countDown").css("border-radius", "2px");
          jQuery("#ac_countDown").css("border", "#000 1px solid");
          jQuery("#ac_countDown").css("padding", "12px 44px 14px;");
          
          
          var endTime = end_date;
          // Increment seconds by 1
          currentSeconds++;
  
          // Adjust minutes, hours, and day if necessary
          if (currentSeconds >= 60) {
            currentSeconds = 0;
            currentMinutes++;
            if (currentMinutes >= 60) {
              currentMinutes = 0;
              currentHours++;
              if (currentHours >= 24) {
                currentHours = 0;
                currentDay++;
              }
            }
          }
  
          // Reformat the updated timestamp
          let currentStoreTime = `${currentYear}-${currentMonth.toString().padStart(2, '0')}-${currentDay.toString().padStart(2, '0')}T${currentHours.toString().padStart(2, '0')}:${currentMinutes.toString().padStart(2, '0')}:${currentSeconds.toString().padStart(2, '0')}`;
          endTime = (Date.parse(endTime) / 1000);
          var now = currentStoreTime;
          now = (Date.parse(now) / 1000);
          var timeLeft = endTime - now;
          var days = Math.floor(timeLeft / 86400);
          var hours = Math.floor(timeLeft / 3600);
          var exactHour = hours % 24;
          var minutes = Math.floor((timeLeft - (hours * 3600)) / 60);
          var seconds = Math.floor((timeLeft - (hours * 3600) - (minutes * 60)));
          var isDays = false;
          if (days > 0 || hours > 24) { isDays = true; }
          if (days < 0) { days = "00"; /*hours = "0"; minutes = "0"; seconds = "0";*/ }
          if (hours < 10) { hours = "0" + hours; }
          if (minutes < 10) { minutes = "0" + minutes; }
          if (seconds < 10) { seconds = "0" + seconds; }
          if (timeLeft > 0) {
            if (isDays) {
              jQuery(".ac__days").html(days); jQuery(".ac__hours").html(exactHour); jQuery(".ac__minutes").html(minutes);jQuery(".ac__seconds").html(seconds);
             // jQuery(".ac_sec, .ac__colon.seconds").hide();
            }
            else {
              jQuery(".ac__hours").html(exactHour); jQuery(".ac__minutes").html(minutes); jQuery(".ac__seconds").html(seconds);
              jQuery(".ac_day, .ac__colon.hours").hide(); jQuery(".ac_sec, .ac__colon.seconds").show();
            }
          }
          else { jQuery('.ac__settings__table, #ac_countDown_container').remove(); }
  
          setTimeout(function () {
            jQuery('.ac__settings__table').before(jQuery("#ac_countDown_container"));
          }, 500);
        }
      }
}   

  var hide_buttons = null;
  var HideAdditionalPayments = function() {      
    hide_buttons = setInterval(function() {
      if(jQuery('.shopify-payment-button__button').length>0){
        jQuery('.shopify-payment-button__button').hide();
        clearInterval(hide_buttons);
      }
    }, 500);
  }

  this.DisplayTiersFn = function () {
    
      setTimeout(function () {
          jQuery('.ac__settings__table').remove();
          var selectedVariant = jQuery('input[name^=id]:checked, select[name^=id], input[name=id], hidden[name^=id]', jQuery('form[action="/cart/add"]')).val();
        let ProductPage = globalFields.TableProductPage != undefined && globalFields.TableProductPage !=  '' ? globalFields.TableProductPage : 'true';
          ProductPage =  ProductPage == 'true' ? true: false;
         if (selectedVariant != null && globalFieldsProductPage_AC.productMetafield != '[]' && globalFieldsProductPage_AC.productMetafield != undefined && ProductPage) {
           let tierObj = globalFields.GetTierObject(globalFieldsProductPage_AC.productMetafield, selectedVariant);
           let DiscountAppliedOn = tierObj.DiscountAppliedON != null &&  tierObj.DiscountAppliedON  != '' &&  tierObj.DiscountAppliedON != undefined ? true : false;
            let Location_Tag_s = tierObj.Location_Tag_ != null &&  tierObj.Location_Tag_  != '' &&  tierObj.Location_Tag_ != undefined ? true : false;
           if(DiscountAppliedOn){
             // 1
             if(Location_Tag_s){
               // 2
              let DiscountAppliedOnTag = tierObj.DiscountAppliedON == 'Both_Store' || tierObj.DiscountAppliedON == 'Online_Store' ? true : false;
           
              let LocationObject = Object.keys(tierObj.Location_Tag_);
              if(LocationObject[0] == 'StoreLocation'){
              let StoreLocationcheck =  tierObj.Location_Tag_[LocationObject[0]].includes(globalFields.Storecountry) || tierObj.Location_Tag_[LocationObject[0]].includes(globalFields.Storecity) ? true : false;
              if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date) && DiscountAppliedOnTag && StoreLocationcheck) {
              var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
              getDates.valid; getDates.start_date; getDates.end_date;
              let timer_settings = parsed_timer_settings;                
              WriteTableHeading(tierObj);
              WriteTableRows(tierObj, selectedVariant);
                                  if (intervalId) {
                  clearInterval(intervalId);
                  }
              if(timer_settings != undefined){                
                if(timer_settings.TimerStatus){  
                  if(getDates.valid){
                     
              
              // Create a new interval and store its ID
              intervalId = setInterval(function () {
              makeTimer(getDates.end_date);
              }, 1000);
                  }
                }
            }
                jQuery('.shopify-payment-button__button').hide();
                setTimeout(function(){
                  jQuery('.shopify-payment-button__button').hide();
                HideAdditionalPayments();
                }, 2000);
                setTimeout(function(){
                  clearInterval(hide_buttons);
                }, 5000);
              } 
              }
              else{
                // 3
                   let TierLocation = tierObj.Location_Tag_[LocationObject[0]];
                   let CusotmerCountryLocation = globalFields.Customercountry;
                   let CusotmerCityLocation = globalFields.Customercity;
                   let CustomerLocationcheck_1 = (arr, arr1) =>{return arr.some(item => arr1.includes(item))};
                   let CustomerLocationcheck_2 = (arr2, arr3) =>{return arr2.some(item => arr3.includes(item))};
                   let CityValue = CustomerLocationcheck_1(TierLocation,CusotmerCountryLocation);
                   let CountryValue = CustomerLocationcheck_2(TierLocation,CusotmerCityLocation);
                  
              if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date) && DiscountAppliedOnTag && (CityValue || CountryValue)) {
              var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
              getDates.valid; getDates.start_date; getDates.end_date;
              let timer_settings = parsed_timer_settings;                
              WriteTableHeading(tierObj);
              WriteTableRows(tierObj, selectedVariant);
                                  if (intervalId) {
                  clearInterval(intervalId);
                  }
              if(timer_settings != undefined){                
                if(timer_settings.TimerStatus){  
                  if(getDates.valid){
                    
              
              // Create a new interval and store its ID
              intervalId = setInterval(function () {
              makeTimer(getDates.end_date);
              }, 1000);
                  }
                }
            }
                jQuery('.shopify-payment-button__button').hide();
                setTimeout(function(){
                  jQuery('.shopify-payment-button__button').hide();
                HideAdditionalPayments();
                }, 2000);
                setTimeout(function(){
                  clearInterval(hide_buttons);
                }, 3000);
              } 
               }
          
              }
             else{
               // 4
              if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date) && (tierObj.DiscountAppliedON == 'Both_Store' || tierObj.DiscountAppliedON == 'Online_Store')) {
              var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
              getDates.valid; getDates.start_date; getDates.end_date;
              let timer_settings = parsed_timer_settings;                
              WriteTableHeading(tierObj);
              WriteTableRows(tierObj, selectedVariant);
                 //makeTimer(getDates.end_date)
                  if (intervalId) {
                  clearInterval(intervalId);
                  }
              if(timer_settings != undefined){                
                if(timer_settings.TimerStatus){  
                  if(getDates.valid){
 
              
              // Create a new interval and store its ID
              intervalId = setInterval(function () {
              makeTimer(getDates.end_date);
              }, 1000);
                  }
                }
            }
                jQuery('.shopify-payment-button__button').hide();
                setTimeout(function(){
                  jQuery('.shopify-payment-button__button').hide();
                HideAdditionalPayments();
                }, 2000);
                setTimeout(function(){
                  clearInterval(hide_buttons);
                }, 2000);
              } 
             }
           }
           else{
             // 5
              if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date)) {
              var getDates = globalFields.TimerStartEndDateValid(tierObj.start_date, tierObj.end_date);
              getDates.valid; getDates.start_date; getDates.end_date;
              let timer_settings = parsed_timer_settings;                
              WriteTableHeading(tierObj);
              WriteTableRows(tierObj, selectedVariant);
                                  if (intervalId) {
                  clearInterval(intervalId);
                  }
              if(timer_settings != undefined){                
                if(timer_settings.TimerStatus){  
                  if(getDates.valid){

              
              // Create a new interval and store its ID
              intervalId = setInterval(function () {
              makeTimer(getDates.end_date);
              }, 1000);
                  }
                }
            }
                jQuery('.shopify-payment-button__button').hide();
                setTimeout(function(){
                  jQuery('.shopify-payment-button__button').hide();
                HideAdditionalPayments();
                }, 2000);
                setTimeout(function(){
                  clearInterval(hide_buttons);
                }, 2000);
              }
           }   
          }
          }, 200);
    }
  
  setTimeout(function(){
    clearInterval(hide_buttons);
  }, 10000);

  this.OnVariantChange = function () {
      setTimeout(function () {
          $(".swatch_options label").click(function () {
              // displayTiers.DisplayTiersFn();
          });
      }, 2000);
  }


  

  var TableHeadHtml = function (contentHtml, tableSelector, position) {
      jQuery(tableSelector).before(contentHtml)
  }

  var WriteTableHeading = function (tierObj) {
   
    var tableSelector = '.purchase-details button[name="add"]';
      if (globalFields.settings.selected_table == "table1") {
          TableHeadHtml('<div class="ac__settings__table ac_table1" id="ac_table1"><div class="ac__tbody"><div class="ac__tr ac__tr1"><th class="ac__th ac__th1">' + globalFields.settings.table_headers.header1_value + '</th><th class="ac__th ac__th2">' + globalFields.settings.table_headers.header2_value + '</th></div></div></div>', tableSelector);
      }
      if (globalFields.settings.selected_table == "table2") {

          TableHeadHtml('<div class="ac__settings__table ac_table2" id="ac_table2"><div class="ac_table_heading ac__tr ac__tr1"><span class="ac__th ac__th1">' + globalFields.settings.table_headers.header1_value + '</span><span class="ac__th ac__th2">' + globalFields.settings.table_headers.header2_value + '</span><span class="ac__th ac__th3">' + globalFields.settings.table_headers.header3_value + '</span></div><div class="ac__tbody ac_grid_box"></div></div>', tableSelector);
      }
      if (globalFields.settings.selected_table == "table3") {
          TableHeadHtml('<div class="ac__settings__table" id="ac_table3"><div class="ac__tbody"><div class="ac__tr ac__tr1"><th class="ac__th ac__th1">'+ '<span class="ac_tire_table_heading">'+globalFields.settings.table_headers.header1_value +  globalFields.settings.table_headers.header2_value+ globalFields.settings.table_headers.header3_value+ '</span></th></div></div></div>', tableSelector);
      }
      if (globalFields.settings.selected_table == "table4") {
          TableHeadHtml('<div class="ac__settings__table ac_table4" id="ac_table4"><div class="ac__tbody"></div></div>', tableSelector);
      }
  }

  var TableRowHtml = function (contentHtml, tableSelector) {
      jQuery(tableSelector).append(contentHtml);
  }

  var TableRowSingle = function (tieredMin_, tieredMax_, discountedPrice, tieredOff,percentSymoby,offvalue, index,lastindex) {
      var plusSign = tieredMin_ == tieredMax_ ? '' : '+', buyText = 'Buy ';
      var priceHtml = '<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + discountedPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(discountedPrice, globalFields.amount) + '</span>';
      if (globalFields.settings.selected_table == "table1") {
          TableRowHtml('<div class="ac__tr ac__tr' + (index + 1) + '"><input type="checkbox"/>Buy<span class="">' + tieredMin_ + plusSign + '</span><span class="">' + tieredOff + '</span></div>', '#ac_table1 .ac__tbody');
      }

      if (globalFields.settings.selected_table == "table2") {
         if(index  == lastindex){
          TableRowHtml('<div class="ac_border_right ac__tr ac__tr' + (index + 1) + '"> <span class="ac__td ac__td3" style="font-size:32px;font-weight:500;">' + tieredOff  + ' </span>' +  percentSymoby + offvalue+' <p class="ac_items_value"><span style="font-weight:500;padding-right:2px;">Any</span><span class="ac__td ac__td1">' + tieredMin_ + '</span><span class="ac__td ac__td2">' + tieredMax_ + '</span><span style="font-weight:500;padding-left:2px;">items</span></p></div>', '#ac_table2 .ac__tbody');
         }else{
             TableRowHtml('<div class="ac_border_right ac__tr ac__tr' + (index + 1) + '"> <span class="ac__td ac__td3" style="font-size:32px;font-weight:500;">' + tieredOff  + ' </span>' +  percentSymoby + offvalue+' <p class="ac_items_value"><span style="font-weight:500;padding-right:2px;">Any</span><span class="ac__td ac__td1">' + tieredMin_ + '</span>-<span class="ac__td ac__td2">' + tieredMax_ + '</span><span style="font-weight:500;padding-left:2px;">items</span></p></div>', '#ac_table2 .ac__tbody');
         }
      }

      if (globalFields.settings.selected_table == "table3") {
       TableRowHtml('<div class="ac__tr ac__tr' + (index + 1) + '"><div class="ac_tier_discount"><span class="ac__td ac__td1"><input type="radio" title="selectedcheckbox" name="buyOption" id="selectedcheckbox'+tieredMin_+'" value="' + tieredMin_ + '"> <span class="ac_tire_padding_left">Buy</span> <span class="ac_tire_padding_left1">' + tieredMin_ + '</span></span><span class="ac__td ac__td2 ac_tire_green_clr">' + tieredOff + '</span></div><div><span class="ac__td ac__td3">' + priceHtml + '</span></div></div>', '#ac_table3 .ac__tbody');
      }

      if (globalFields.settings.selected_table == "table4") {
          var quantityTextTable4 = tieredMin_ + "-" + tieredMax_;
          if (tieredMax_ == "+") {
              quantityTextTable4 = tieredMin_ + "+";
          }
          TableRowHtml('<div class="ac__tr ac__tr' + index + '"> <span class="ac__td ac__td1">' + globalFields.settings.table_body.body1_value + ' ' + tieredMin_ + ' ' + globalFields.settings.table_body.body2_value + ' ' + tieredOff + '</span></div>', '#ac_table4');
      }
  }


  

  var WriteTableRows = function (tierObj, selectedVariant_) {
      var originalPrice_ = globalFieldsProductPage_AC.variantsPriceArray_PD[selectedVariant_]; originalPrice_ = originalPrice_ / 100;
      for (i = 0; i < tierObj.tier_min.length; i++) {
          var isBreakLoop = false, tieredOff = Number(tierObj.tier_values[i]),percentSymoby= "",offvalue = '';
          var tieredMin_ = parseInt(tierObj.tier_min[i]), tieredMax_ = tierObj.tier_max[i], discountedPrice = 0;
          if (tieredMax_ != "max") {
              tieredMax_ = parseInt(tieredMax_);
          }else {
              tieredMax_ = "+";
          }

          if (tierObj.discount_type == "percentage") {
              discountedPrice = Number(originalPrice_.toFixed(2));
              var p = parseFloat(tieredOff) / 100, originalPriceCut_ = Number(parseFloat(p * discountedPrice).toFixed(2));
              discountedPrice = discountedPrice - originalPriceCut_;
              if (discountedPrice <= 0) {
                  discountedPrice = 0;
                  tieredOff = "100";
                  isBreakLoop = true;
                  tieredMax_ = "+";
                percentSymoby =  '<span style="position: relative;bottom: 15px;font-size: 18px;right: 5px;font-weight:500;">%</span>';
                 offvalue = '<span style="position: relative;right: 20px;top: 5px;font-weight: 500;">OFF</span>';
              }
              else {
                  discountedPrice = discountedPrice.toFixed(2);
                  tieredOff = tieredOff;
                  percentSymoby =  "<span style='position: relative;bottom: 15px;font-size: 18px;right: 5px;font-weight:500;'>%</span>";
                  offvalue = '<span style="position: relative;right: 20px;top: 5px;font-weight: 500;">OFF</span>';
              }
          }
          else if (tierObj.discount_type == "fixed_price") {
              discountedPrice = tieredOff.toFixed(2);
              tieredOff = globalFields.formatMoney(tieredOff.toFixed(2), globalFields.amount);
          }
          else {
              discountedPrice = Number((originalPrice_ - tieredOff).toFixed(2));
              if (discountedPrice <= 0) {
                  discountedPrice = 0;
                  tieredOff = globalFields.formatMoney(originalPrice_.toFixed(2), globalFields.amount);
                  isBreakLoop = true;
                  tieredMax_ = "+";
              }
              else {
                  discountedPrice = discountedPrice.toFixed(2);
                  tieredOff = globalFields.formatMoney(tieredOff.toFixed(2), globalFields.amount);
                  offvalue = '<span>OFF</span>';
              }
          }

          TableRowSingle(tieredMin_, tieredMax_, discountedPrice, tieredOff,percentSymoby,offvalue, i + 1,tierObj.tier_min.length);

          if (isBreakLoop) { break; }
      }
  } 

}

let newdatacheck = '';

$(document).on('click', 'input[name="paywhirl-plan-selector-group"]', function() {
    newdatacheck = $(this).prop('checked') && $(this).siblings('span').text();
    
    if (newdatacheck === "Subscribe & Save 15%") {
        $('#ac_table2').hide();
    } else {
        $('#ac_table2').show();
        OnchangePrice();
    }
});

$(document).on('click', '.swatch_options label', function() {
    if (newdatacheck === "Subscribe & Save 15%") {
        $('#ac_table2').hide();
    } else {
        $('#ac_table2').show();
        OnchangePrice();
    }
});


  setTimeout(function() {
     if(jQuery('.flickity-viewport:first')[0] != undefined){
      if(jQuery('.flickity-viewport:first')[0].style.height == '0px'){
        location.reload();
      }
    }
  }, 600);

  var OnchangePrice = function () {
    setTimeout(function() {
      var selectedVariant = jQuery('input[name^=id]:checked, select[name^=id], input[name=id], hidden[name^=id]', jQuery('form[action="/cart/add"]')).val();
     let currencyRate = Shopify.currency.rate;
    currencyRate = Number(currencyRate);
    if(selectedVariant == ""){ 
          let id_= Object.keys(globalFieldsProductPage_AC.variantsPriceArray_PD)
          selectedVariant = id_[0];
        }
      var mainProductPrice = globalFieldsProductPage_AC.variantsPriceArray_PD[selectedVariant];
      var mainProductPriceWithMoney  = globalFields.formatMoney(mainProductPrice, globalFields.amount);
        var originalChangeQty = jQuery('input[name="quantity"]').val();
        originalChangeQty = Number(originalChangeQty);
        if(isNaN(originalChangeQty)){
        	originalChangeQty = 1;
        }
        var updatedItemPrice = 0
   let selectedInput = $('input[name="paywhirl-plan-selector-group"]:checked');
let isSubscribeSaveProduct = selectedInput.length && selectedInput.siblings('span').text();
   if (isSubscribeSaveProduct == "Subscribe & Save 25%") {
     return
   }
        if (selectedVariant != null && globalFieldsProductPage_AC.productMetafield != '[]' && globalFieldsProductPage_AC.productMetafield != undefined && selectedVariant != ""  ) {
          var tierObj = globalFields.GetTierObject(globalFieldsProductPage_AC.productMetafield, selectedVariant);
          if (tierObj != undefined && tierObj.status && globalFields.StartEndDateValid(tierObj.start_date, tierObj.end_date)) {
            for (i = 0; i < tierObj.tier_min.length; i++) {
              var tierPrice = parseFloat(tierObj.tier_values[i]);
              var minTier = parseInt(tierObj.tier_min[i]), maxTier = tierObj.tier_max[i] != 'max' ? parseInt(tierObj.tier_max[i]) : tierObj.tier_max[i];
              var updatedLinePrice = 0, condition1 = false, condition2 = false;
              var originalPrice_ = (mainProductPrice / 100);
                  originalPrice_ = originalPrice_;
				 originalPrice_ = Number(originalPrice_ );
              condition1 = originalChangeQty >= minTier;
              condition2 = maxTier == "max" || originalChangeQty <= maxTier;
              if (condition1 && condition2) { break; }
            }
            
            if (condition1 && condition2) {
                if (tierObj.discount_type == 'percentage') {
                    var originalPriceCut = parseFloat(globalFields.ConvertToFixedDecimalNumber((parseFloat(tierPrice) / 100) * globalFields.ConvertToFixedDecimalNumber(originalPrice_)));
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(originalPrice_) - originalPriceCut);
                }
                else if (tierObj.discount_type == 'fixed') {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(originalPrice_) - parseFloat(tierPrice * currencyRate));
                }
                else if (tierObj.discount_type == 'fixed_price') {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(parseFloat(tierPrice * currencyRate));
                }
              
                updatedItemPrice = globalFields.formatMoney(Number(updatedItemPrice).toFixed(2), globalFields.amount);
            
              jQuery('.main .product .modal_price').html(`<div class="price__container price__container--display-price-false "> <span content="${originalPrice_}" class=""> <span class="current_price"><span class="money"><s class="ac-discounted-price">${mainProductPriceWithMoney}</s> ${updatedItemPrice}</span></span></span></span></div>`)
            }
            else{
              
              jQuery('.main .product .modal_price').html(`<div class="price__container price__container--display-price-false "> <span content="${originalPrice_}" class=""> <span class="current_price"><span class="money">${mainProductPriceWithMoney}</span></span></span></span></div>`)
             // jQuery('.prod-bottom-sticky .prod-bottom-details .prod-price').html(`<p class="price__regular anncode" id="price_ppr"><span class="money pre-money" data-product-id="${globalFields.ProductOrinalId}" style="visibility: visible;"> ${mainProductPriceWithMoney} </span><p>`)
            }
          }
          }
        else{
          jQuery('.main .product .modal_price').html(`<div class="price__container price__container--display-price-false "> <span content="${originalPrice_}" class=""> <span class="current_price"><span class="money">${mainProductPriceWithMoney}</span></span></span></span></div>`)
         // jQuery('.prod-bottom-sticky .prod-bottom-details .prod-price').html(`<p class="price__regular anncode" id="price_ppr"><span class="money pre-money" data-product-id="${globalFields.ProductOrinalId}" style="visibility: visible;"> ${mainProductPriceWithMoney} </span><p>`)
          } 
    }, 1000);
  }

var globalFieldsProductPage_AC = new ACDiscountApp.PDPage.Global(), displayTiers = new ACDiscountApp.PDPage.DisplayTiers();
displayTiers.DisplayTiersFn(); displayTiers.OnVariantChange();OnchangePrice();
window.addEventListener("load", (event) => {
setTimeout(function() {
displayTiers.DisplayTiersFn(); displayTiers.OnVariantChange();OnchangePrice();
}, 1600);
});

